import React from 'react';
import styled from 'styled-components';

import MetaTags from 'components/meta-tags';
import ResetPasswordForm from 'components/forms/reset-password-form';
import ArrowLeft from 'src/assets/arrow-left';
import type { IrlEvent } from 'src/gql/graphql';
import { Card, CardFooter } from './card';
import { BackButton, ContentHeader, Heading, Description, FormWrapper, Content } from './styles';
import { IrlEventLogo } from './irl-event-logo';

type IrlEventForgotPasswordProps = {
  irlEvent: IrlEvent;
  onBack?: () => void;
  onResetSuccess?: () => void;
};

export function IrlEventForgotPassword({ irlEvent, onBack, onResetSuccess }: IrlEventForgotPasswordProps): JSX.Element {
  const footer = (
    <CardFooter>
      <StyledBackButton onClick={onBack} data-testid='irl-event-forgot-password-back-link'>
        <StyledArrowLeft height={11} width={15} />
        Log in again
      </StyledBackButton>
    </CardFooter>
  );

  return (
    <>
      <MetaTags title='Reset Password' description='Reset your password' />

      <Card footer={footer} data-testid='irl-event-forgot-password'>
        <IrlEventLogo headerImageUrl={irlEvent.headerImageUrl ?? null} />

        <ContentHeader>
          <Heading>Reset your password</Heading>
          <Description>
            Enter the email address associated with your account and we'll email you a link to reset your password.
          </Description>
        </ContentHeader>

        <Content>
          <StyledFormWrapper>
            <ResetPasswordForm onClose={onResetSuccess} />
          </StyledFormWrapper>
        </Content>
      </Card>
    </>
  );
}

// Hide the form's internal "Log in again" link
const StyledFormWrapper = styled(FormWrapper)`
  .login-again-link {
    display: none;
  }
`;

const StyledArrowLeft = styled(ArrowLeft)`
  flex-shrink: 0;
`;

const StyledBackButton = styled(BackButton)`
  justify-self: center;
`;
